@switch (displayMode) {
    @case ("Kanban") {
        <div class="fancy-scrollbar-newUI wk-view__container" cdkScrollable>
            @for (columnData of columns; track columnData.id) {
                <column-component
                    [hidden]="columnData.state !== 'notStarted' || columnData.id === 'all_steps_not_started'"
                    [isHidden]="columnData.state !== 'notStarted' || columnData.id === 'all_steps_not_started'"
                    [columnData]="columnData"
                />
            }
        </div>
    }

    @case ("details") {
        <app-assignees-view />
    }

    @case ("List") {
        <div class="wk-view__steps-selector">
            <div class="wk-view__steps-selector--flex">
                <div class="wk-view__steps-selector--label">{{ "ViewComponent.ViewStep" | translate }}{{ "General.Colon" | translate }}</div>
                @for (pillInfo of listPillInfo; track pillInfo.id) {
                    <div
                        class="wk-view__step"
                        [class.selected]="selectedStepId === pillInfo.id"
                        title="{{ pillInfo.columnName | wkTranslate }}"
                        (click)="stepSelection(pillInfo.id, pillInfo.columnName)"
                    >
                        {{ pillInfo.columnName | wkTranslate }}
                    </div>
                }
            </div>
            <div>
                @if (userCanPrintExport) {
                    <span class="wk-print-button" (click)="printPage()"><i class="fa fa-print fa-inverse" aria-hidden="true"></i></span>
                }
            </div>
        </div>
        <div id="virtual-scroller-wrapper" class="wk-list-virtual-scroller-wrapper">
            <div class="row table-row table-header">
                <div class="col-md-3">
                    @if (countersService.isLoadingColumn[selectedStepId]) {
                        <div class="wk-card-grid-loading-spinner-wrapper wk-taxpayer-count">
                            <app-loader text="General.LoadingCards" [isOverlay]="false" [size]="'button'" />
                        </div>
                    } @else {
                        <i class="fa fa-user wk-taxpayer-count" aria-hidden="true"></i>
                    }
                    {{ "General.Name" | translate }}
                </div>
                <div class="col-md-2">{{ "Board.FamilyMember" | translate }}</div>
                @if (showLastYearReceivedDateColumn) {
                    <div class="col-md-5">{{ "NotStarted.LastYearReceivedDate" | translate }}</div>
                }
                <div class="col-md-2">{{ "Dashboard.Category" | translate }}</div>
            </div>
            @for (columnData of columns; track columnData.id) {
                <div [class.single-column]="columnData.state === 'notStarted'">
                    <column-component [printing]="printing" [scrollbarGutterStable]="true" [columnData]="columnData" />
                </div>
            }
        </div>
        <div class="wk-view__board-returns">
            <i class="fa fa-user wk-taxpayer-count" aria-hidden="true"></i>
            <span> {{ numberOfReturn }} {{ "Board.Returns" | translate }} </span>
        </div>
    }
}
<router-outlet />
